import React from 'react';
import { Fab, Hidden, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PhoneIcon from '@material-ui/icons/Phone';
import siteConfig from '../siteConfig';

const useStyles = makeStyles((theme) => ({
  fab: {
    // Bottom-left, because Netlify's badge sits in the bottom-right corner.
    position: 'fixed',
    left: theme.spacing(2),
    bottom: theme.spacing(2),
    zIndex: theme.zIndex.appBar - 1,
    fontWeight: 700,
    boxShadow: '0 8px 24px rgba(14,35,64,0.3)',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));

// A floating "Call" button for phones and tablets.
export default function MobileCallButton() {
  const classes = useStyles();
  // On very narrow phones, a shorter label keeps the button clear of the badge.
  const narrow = useMediaQuery('(max-width:359.95px)');

  return (
    <Hidden mdUp implementation="css">
      <Fab
        variant="extended"
        color="secondary"
        href={siteConfig.phoneHref}
        className={classes.fab}
        aria-label={`Call ${siteConfig.phoneDisplay}`}
      >
        <PhoneIcon className={classes.icon} />
        {narrow ? 'Call' : 'Call now'}
      </Fab>
    </Hidden>
  );
}
